import { useCard } from "src/hooks/useCard";
import { ThemeBackground } from "src/components/GroupVideoTheme/ThemeBackground";
import { useCardTheme } from "src/components/GroupVideoTheme/useCardTheme";
import { User } from "src/libs/user-lib";
import { CardUserRelationshipBadge } from "./CardUserRelationshipBadge";

type GroupVideoListThumbnailProps = {
  cardId?: string | null;
  cardUrl?: string | null;
  user?: User | null;
  isContributor?: boolean;
};

export const GroupVideoListThumbnail = ({
  cardId = null,
  cardUrl = null,
  user = null,
  isContributor = false,
}: GroupVideoListThumbnailProps) => {
  const useCardQuery = useCard(cardId, cardUrl);
  const card = useCardQuery.result?.card;

  const { theme } = useCardTheme({
    themeId: card?.themeId,
    occasionId: card?.occasionId,
  });

  const isOwner = Boolean(user?.username && user.username === card?.username);
  const isCardContributor = isContributor;
  const isCollaborator = Boolean(
    card?.collaborators?.find(
      (collaborator) => collaborator.username === user?.username
    )
  );

  // Use the occasion default icon if the user didn't upload one
  const featureImageUrl =
    card?.featureImageUrl ||
    theme?.featureImageUrl ||
    "/images/placeholders/default-birthday.jpg";

  return (
    <div className="relative z-0 h-[210px] w-full">
      <ThemeBackground themeId={card?.themeId} backgroundSize="cover">
        <div className="absolute z-10 mt-2 ml-2">
          <CardUserRelationshipBadge
            isOwner={isOwner}
            isContributor={isCardContributor}
            isCollaborator={isCollaborator}
          />
        </div>
        <img
          src={featureImageUrl}
          alt={card?.title}
          className="absolute top-1/2 left-1/2 h-5/6 -translate-x-1/2 -translate-y-1/2 rounded-full p-1 sm:h-2/3 md:h-3/4"
        />
      </ThemeBackground>
    </div>
  );
};
